import { cn } from "../lib/cn";
import { CallSketch, SB_MONO } from "./CallSketch";

/**
 * Features, "Code context, live.": Jon can't find a function, and the code card pops up, as the product
 * draws a code_reference card (the function, file · repo, one plain line, the words heard). No code is
 * ever shown, as in the product.
 */
export const CODE_SKETCH = {
  speaker: "Jon",
  said: "I can't find the function that refreshes the login token. Where is it?",
  symbol: "refreshToken",
  file: "src/auth/refresh-token.ts · acme/app",
  summary: "Renews the access token before it expires.",
  heard: "the function that refreshes the login token",
} as const;

export function CodeCardSketch() {
  return (
    <CallSketch speaker={CODE_SKETCH.speaker} said={CODE_SKETCH.said} app="github" label="Code">
      <p className="text-[11px] font-semibold leading-tight">{CODE_SKETCH.symbol}</p>
      <p className={cn("text-[8px] leading-snug text-[#94A3B8]", SB_MONO)}>{CODE_SKETCH.file}</p>
      <p className="mt-1 text-[9.5px] leading-snug text-[#cbd5e1]">{CODE_SKETCH.summary}</p>
      <p className="mt-1 text-[8.5px] leading-snug text-[#94A3B8]">
        <span className={cn("mr-1 rounded border border-[rgba(148,163,184,0.3)] px-1 text-[7.5px]", SB_MONO)}>heard</span>
        {CODE_SKETCH.heard}
      </p>
    </CallSketch>
  );
}
